export const EVENT_ID = {
  DAILY_EVENT: 34,
  WEEKLY_EVENT: 75,
  TOURNAMENT_EVENT: 150,
  BCS_EVENT: 149,
};

